const FAQS = [
  {
    q: '51视频需要注册才能观看吗？',
    a: '不需要。51视频所有内容均开放观看，无需注册、登录或付费，打开即可直接播放高清视频，真正做到即点即看，没有任何门槛。',
  },
  {
    q: '播放视频时出现卡顿怎么办？',
    a: '51视频采用多线CDN智能分发技术，系统会自动为您匹配最优播放节点。如遇卡顿，可尝试切换清晰度或刷新页面。建议在网络环境良好时选择4K画质获得最佳观影体验。',
  },
  {
    q: '支持哪些设备观看？',
    a: '51视频全面支持PC端、平板、iOS及Android手机等主流设备。移动端App还提供离线缓存功能，让您在没有网络的情况下也能畅享精彩内容。',
  },
  {
    q: '视频画质怎么样？最高支持多少？',
    a: '51视频提供从流畅到4K超清的多档画质选择，最高支持4K分辨率播放。所有视频源均经过专业转码优化，在保证画质的同时最大限度降低带宽消耗。',
  },
  {
    q: '内容更新频率是怎样的？',
    a: '51视频内容团队每日更新，热门电影、剧集、综艺、动漫等同步上线。每周推出精选专题和编辑推荐，确保您总能看到最新最火的影视内容。',
  },
  {
    q: '51视频是完全免费的吗？有没有隐藏收费？',
    a: '51视频始终坚持完全免费的原则，所有影视内容均可免费在线观看，无任何隐藏收费项目，无VIP会员制度，让每一位用户都能平等享受高清观影乐趣。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">常见问题</h2>
          <p className="text-sm text-foreground-500 mt-2">关于51视频，您想了解的都在这儿</p>
        </div>

        <div className="space-y-3">
          {FAQS.map((faq, idx) => (
            <details key={idx} className="group bg-background-50 border border-background-200/60 rounded-xl overflow-hidden">
              <summary className="flex items-center justify-between cursor-pointer p-4 md:p-5 list-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">{faq.q}</h3>
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-background-100 group-open:bg-primary-100 transition-colors">
                  <i className="ri-arrow-down-s-line text-foreground-500 group-open:text-primary-600 group-open:rotate-180 transition-transform duration-300 text-sm"></i>
                </span>
              </summary>
              <div className="px-4 md:px-5 pb-4 md:pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}